module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-container"
  }, [(_vm.coin) ? [_c('div', {
    staticClass: "menu coin"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "button is-text",
    class: {
      'top-menu-selected': _vm.pageSelected === 'start'
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/')
      }
    }
  }, [_vm._v("Start")]), _c('div', {
    staticClass: "button is-text",
    class: {
      'top-menu-selected': _vm.pageSelected === 'account'
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/account')
      }
    }
  }, [_vm._v("Account")]), _c('div', {
    staticClass: "button is-text",
    class: {
      'top-menu-selected': _vm.pageSelected === 'address'
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/address')
      }
    }
  }, [_vm._v("Address")]), _c('div', {
    staticClass: "button is-text",
    class: {
      'top-menu-selected': _vm.pageSelected === 'referral'
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/referrals')
      }
    }
  }, [_vm._v("Referrals")]), _c('div', {
    staticClass: "button is-text margin-top-mobile-486",
    class: {
      'top-menu-selected': _vm.pageSelected === 'support'
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/support')
      }
    }
  }, [_vm._v("Support")]), _c('div', {
    staticClass: "button is-text app-menu-item hint--top",
    class: {
      'top-menu-selected': _vm.pageSelected === 'app'
    },
    attrs: {
      "aria-label": "Easy monitoring from your pocket"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/app')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile"
  }), _c('span', [_vm._v("App")])]), _c('div', {
    staticClass: "button is-text hint--top download-top margin-top-mobile",
    attrs: {
      "aria-label": "For beginners and experienced miners"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/start')
      }
    }
  }, [_c('b', [_vm._v("Get started  🚀")])]), _c('div', {
    staticClass: "button is-text mode-selector hint--top",
    attrs: {
      "aria-label": "Toggle light / dark theme",
      "data-mode": _vm.mode
    },
    on: {
      "click": _vm.toggleMode
    }
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-moon-o': _vm.mode === 'light',
      'fa-lightbulb-o': _vm.mode === 'dark'
    }
  })])])])] : [_c('div', {
    staticClass: "menu no-coin has-text-centered"
  }, [_c('div', {
    staticClass: "button is-text",
    class: {
      'top-menu-selected': _vm.pageSelected === 'referral'
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/referrals')
      }
    }
  }, [_vm._v("Referrals")]), _c('div', {
    staticClass: "button is-text",
    class: {
      'top-menu-selected': _vm.pageSelected === 'support'
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/support')
      }
    }
  }, [_vm._v("Support")]), _c('div', {
    staticClass: "button is-text app-menu-item hint--top",
    class: {
      'top-menu-selected': _vm.pageSelected === 'app'
    },
    attrs: {
      "aria-label": "Easy monitoring from your pocket"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/app')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile"
  }), _c('span', [_vm._v("App")])]), _c('div', {
    staticClass: "button is-text hint--top download-top",
    attrs: {
      "aria-label": "For beginners and experienced miners"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/start')
      }
    }
  }, [_c('b', [_vm._v("Get started")])])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a543517a","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_top_bar.vue
// module id = 390
// module chunks = 1